import type { CalculationRecord } from '../types';

const riskBadgeMap: Record<string, string> = {
  'Lower Risk': 'success',
  'Moderate Risk': 'warning',
  'Higher Risk': 'danger',
  'Highest Risk': 'danger',
};

interface ResultCardProps {
  record: CalculationRecord;
  referralNote?: string | null;
}

export function ResultCard({ record, referralNote }: ResultCardProps) {
  const badgeTone = record.riskLevel ? riskBadgeMap[record.riskLevel] ?? 'warning' : 'success';
  const significantCondition = record.mostSignificantCondition ?? 'None selected';

  return (
    <section className="result-card" aria-live="polite">
      <div className="result-metric">
        <span>Risk Level</span>
        <h3>{record.riskLevel ?? 'Not Available'}</h3>
        {record.riskLevel ? (
          <span className={`badge ${badgeTone}`}>{record.riskLevel}</span>
        ) : (
          <span className="badge success">Assessment Ready</span>
        )}
      </div>
      <div className="result-metric">
        <span>Most Significant Condition</span>
        <h3>{significantCondition}</h3>
        <small className="muted">Largest contributor to the calculation.</small>
      </div>
      {referralNote ? (
        <div className="result-metric">
          <span>Referral</span>
          <p className="muted">{referralNote}</p>
        </div>
      ) : null}
    </section>
  );
}
